











































  import {Component, Watch} from 'vue-property-decorator';
  import {mixins} from 'vue-class-component';
  import UrlMixin, { ExcludeTypeEnum } from '@/components/query/url-mixin';
  import { debounce, throttle } from 'lodash';
  import reportUtils from '@/views/reports/report-utils';
  import query from '@/components/query/query-constructor';
  import MainMenuComplexTabsMixin from '@/views/layout/navigation/mixins/main-menu-complex-tabs-mixin';
  import MenuDrilldownBreadcrumbs, { MenuDrilldownBreadcrumbsWidths } from '@/views/reports/views/menu-drilldown/menu-drilldown-breadcrumbs.vue';
  import MenuDrilldownMenuListItem from '@/views/reports/views/menu-drilldown/menu-drilldown-menu-list-item.vue';
import { DrillFilterOptionsEnum } from '../../../../services/models/Enums';

  @Component({
    components: {
      MenuDrilldownBreadcrumbs,
      MenuDrilldownMenuListItem
    }
  })
  export default class MenuDrilldown extends mixins(UrlMixin, MainMenuComplexTabsMixin) {
    drill: any[] = [];
    close: boolean = true;
    showScroll: boolean = false;
    width: number = 0;
    widths: MenuDrilldownBreadcrumbsWidths = null;
    buttonWidthEstimate: number = 120;

    mounted() {
      this.utils.resolveReportNavigation(this.drilldown, {
        isReplaceTab: false,
        isInit:true
      });

      this.bus.on('tab-add', this.onBusTabAdd);
      window.addEventListener('resize', this.onWindowResizeThrottled);
    }

    beforeDestroy() {
      this.bus.off('tab-add', this.onBusTabAdd);
      window.removeEventListener('resize', this.onWindowResizeThrottled);
    }

    get onWindowResizeThrottled() {
      return throttle(this.onWindowResize, 500);
    }

    onWindowResize() {
      this.recalcWidth();
    }

    get isReportComputed() {
      return this.isReport();
    }

    @Watch('isReportComputed', { immediate: true })
    onisReportComputedChanged(value: boolean) {
      if(value) {
        this.$helpers.afterBrowserRedraw(this.recalcWidth);
      }
    }

    recalcWidth() {
      const el = this.$refs.menuDrilldown as Element;

      if(!this.isReport() || !el) {
        return;
      }
      
      const rect = el.getBoundingClientRect();
      this.width = rect.width - this.buttonWidthEstimate;
    }

    onBusTabAdd(reportLink: any) {
      this.$router.push(reportLink, () => {
        this.utils.resolveReportNavigation(this.drilldown, {
          isAddTab: true
        });
      });
    }

    handleBreadcrumbsResize(value: MenuDrilldownBreadcrumbsWidths) {
      this.widths = value;
    }

    handleCloseDrilldown(index: any) {
      this.bus.emit('freeze-table');

      this.$helpers.afterBrowserRedraw(() => { 
        this.drilldownBack(index);
        this.bus.emit('reload-report');
      });
    }

    handleSliceExclude(item: Bemob.ReportQueryDrill) {
      this.drilldownForward(null, {
        tableNextReportExclude: item.filterOptions === DrillFilterOptionsEnum.not_equals,
        tableNextReport: item.filterValues,
        tableNextReportGroup: item.filterTables,
        tableSelectedItems: [
          {
            DT_RowId: item.filterValues
          }
        ],
        tableNextReportExcludeType: ExcludeTypeEnum.slice      
      });

      this.bus.emit('reload-report');
    }

    getDefaultWidths(): MenuDrilldownBreadcrumbsWidths {
      return {
        widths: [0],
        dividerWidth: 16
      }
    }

    get lastVisibleIndex() {
      const data = this.widths || this.getDefaultWidths();
      let i = 0;
      let width = 0;

      while(i < data.widths.length && width < this.width) {
        const dividerWidth = i !== 0 
          ? data.dividerWidth
          : 0;

        width += data.widths[i] + dividerWidth;
        i++;
      }

      if(width > this.width) {
        i--;
      }

      const result = i || 1;
      return result;
    }

    drillPostponed: any[] = [];

    @Watch('drill', { immediate: true })
    onDrillChanged(value: any[]) {
      this.$nextTick(() => {
        this.$helpers.afterBrowserRedraw(() => {
          this.drillPostponed = value.map((item) => ({
            ...item,
            key: `${item.filterTables}_${item.filterValues}_${item.filterOptions}`
          }));
        });
      })
    }

    get hiddenDrillsCount() {
      return this.hiddenDrill.length;
    }

    get visibleDrill() {
      return this.drillPostponed.slice(0, this.lastVisibleIndex);
    }

    get hiddenDrill() {
      return this.drillPostponed.slice(this.lastVisibleIndex);
    }

    get restItems() {
      return this.hiddenDrill.map((item) => ({
        key: item.index,
        title: item.text,
        click: () => this.setPosition(item.index)
      }));
    }

    get utils(){
      return reportUtils(this);
    }

    scroll_left() {
      let content = document.getElementById('v-breadcrumbs') as any;
      content.scrollLeft -= 100;
    }

    scroll_right() {
      let content = document.getElementById('v-breadcrumbs') as any;
      content.scrollLeft += 100;
    }

    setPosition(index: any) {
      const {commit} = this.$store;
      let type = this.$route.params.type;
      let report = this.reportQuery();
      let restorePage = {};

      if(report.drill) {
        const drill: Bemob.ReportQueryDrill[] = report.drill.splice(index);

        if(drill.length) {
          const tableTreeLevels = drill.map((e) => e.filterTables)
          this.bus.emit('restore-tree-levels', tableTreeLevels);
          type = tableTreeLevels[0];
        }

        this.drill.splice(index + 1);

        if(!report.drill.length) {
          restorePage = {
            offset: report.filterOffset,
            limit: report.filterLimit
          };
        } else {
          const lastDrillIndex = report.drill.length - 1;

          restorePage = {
            offset: report.drill[lastDrillIndex].filterOffset,
            limit: report.drill[lastDrillIndex].filterLimit
          };
        }
      }

      commit('tableQuery', {
        grouping: this.$route.params.type,
        name: 'drillPosition',
        value: index,
        notSetToLocalStorage: this.isReport()
      });

      this.$router.push(
        { 
          params: { 
            ...this.$route.params,
            report: query.encode(report),
            data: query.encode({
              ...this.dataDecoded,
              ...restorePage
            }),
            type: type
          }
        }, () => {
          this.bus.emit('reload-report');
        }
      );
    }

    updated(){
      let content = document.getElementById('v-breadcrumbs') as any;
      if (!content) return;
      this.showScroll = (content.scrollWidth > 1024);
      content.scrollLeft += (content.scrollWidth - content.offsetWidth + 1);
    }

    @Watch('$route')
    onRouteChanged(value: any) {
      this.utils.resolveReportNavigation(this.drilldown, {
        isReplaceTab: value.params.manualDrilldown
      });
    }
  }

